module.exports = __webpack_public_path__ + "img/star-superkids.afea8359.png";